import { LegalContent } from '@/components/legal/LegalContent';
import { TERMS_CONTENT_BLOCKS } from '@/lib/terms';

export default function TermsAndConditions() {
  return (
    <article className="mx-auto w-full max-w-4xl px-4 py-10 sm:px-6 sm:py-14 lg:px-8">
      <LegalContent blocks={TERMS_CONTENT_BLOCKS} />
    </article>
  );
}
